export default "__VITE_ASSET__DXf$ljNJ__"